import React, { useContext, useMemo } from 'react'

import DataTable from '../../../../Components/shared/DataTable/DataTable'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { InternshipRequestFile, getOriginalName, getType, getTypeColor } from '../../../../utils/entities/internshipRequestFile'
import { ORDER_BY } from '../../../../utils/constants'
import { DeleteAction } from '../../../../Components/shared/DataTable/utils/actions'
import { Tag } from 'antd'
import { InternshipRequestFileModalContext } from '../../../../Providers/Forms/InternshipRequestFileModal'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const InternshipRequestFilesTable = ({ data, individualInternshipRequest, loading, metadata, parameters, onDelete, onParametersChange, reload, t }) => {
  const { setSelectedFile } = useContext(InternshipRequestFileModalContext)

  const columns = useMemo(() => [
    { title: t('data_table.column_title.name'), orderBy: ORDER_BY.ORIGINAL_NAME, key: getOriginalName },
    {
      title: t('data_table.column_title.type'),
      orderBy: ORDER_BY.TYPE,
      key: f => <Tag color={getTypeColor(f)}>{t('indidivual_internship_request_file.types.' + getType(f).toLowerCase())}</Tag>
    }
  ], [t])

  const actions = useMemo(() => [new DeleteAction({ onDelete })], [onDelete])

  return (
    <DataTable
      actions={actions}
      columns={columns}
      data={data}
      loading={loading}
      metadata={metadata}
      parameters={parameters}
      onCreate={() => setSelectedFile({ data: new InternshipRequestFile({ individualInternshipRequest }), callback: reload })}
      onParametersChange={onParametersChange}
    />
  )
}

export default connect(mapStateToProps)(InternshipRequestFilesTable)
